// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__CO3pY","description":"PatientConsentPreview_description__188Kb"};